import { connect } from 'react-redux'
import useSurchargeMargin from 'hooks/Offers/useSurchargeMarginFetcher'
import { getCanViewLuxPlusBenefits } from 'luxPlus/selectors/featureToggle'
import PriceRowMarginText from 'components/OfferPage/PriceRowMarginText'

interface MappedProps {
  canViewLuxPlusBenefits: boolean
  showMarginInSpoofMode: boolean
}

interface Props {
  basePackage: App.Package
  upgradePackage: App.Package
  checkIn?: string
}

function PackageUpgradeSurchargeMarginComparisonText(props: Props & MappedProps) {
  const {
    canViewLuxPlusBenefits,
    checkIn,
    basePackage,
    upgradePackage,
    showMarginInSpoofMode,
  } = props

  // Fetch margins for both base and upgrade packages
  const { surchargeMargin: baseSurchargeMargin } = useSurchargeMargin({
    checkIn,
    duration: basePackage.duration,
    roomRateId: basePackage.roomRate?.id,
  })

  const { surchargeMargin: upgradeSurchargeMargin } = useSurchargeMargin({
    checkIn,
    duration: upgradePackage.duration,
    roomRateId: upgradePackage.roomRate?.id,
  })

  const baseSurchargeMarginAud = baseSurchargeMargin?.status === 'success' ? baseSurchargeMargin.marginAud : 0
  const upgradeSurchargeMarginAud = upgradeSurchargeMargin?.status === 'success' ? upgradeSurchargeMargin.marginAud : 0

  // Margin to remove if user can view LuxPlus benefits
  const baseMarginToRemoveIfOnLuxPlus = canViewLuxPlusBenefits ? basePackage.price - basePackage.memberPrice : 0
  const upgradeMarginToRemoveIfOnLuxPlus = canViewLuxPlusBenefits ? upgradePackage.price - upgradePackage.memberPrice : 0

  // Calculate margins for both packages
  const baseMarginValue = Number.isFinite(basePackage.marginAud) ?
      (basePackage.marginAud ?? 0) - baseMarginToRemoveIfOnLuxPlus :
    0

  const upgradeMarginValue = Number.isFinite(upgradePackage.marginAud) ?
      (upgradePackage.marginAud ?? 0) - upgradeMarginToRemoveIfOnLuxPlus :
    0

  const totalExtraMargin = upgradeMarginValue + upgradeSurchargeMarginAud - baseMarginValue - baseSurchargeMarginAud

  return (
    <>
      {showMarginInSpoofMode && totalExtraMargin > 0 && (
        <PriceRowMarginText
          type="package_upgrade_comparison_positive"
          marginValue={totalExtraMargin}
          colour="highlight-primary-dark"
        />
      )}
    </>
  )
}

const mapStateToProps = (state: App.State) => ({
  showMarginInSpoofMode: state.system.showMarginInSpoofMode,
  canViewLuxPlusBenefits: getCanViewLuxPlusBenefits(state),
})

export default connect(mapStateToProps)(PackageUpgradeSurchargeMarginComparisonText)
